import { getQueryStrings } from '@/lib/utils'

// 获取token
export function getToken() {
  const { token } = getQueryStrings()

  if (!token || token === 'null' || token === 'undefined') return localStorage.getItem('token') || ''

  localStorage.setItem('token', token)

  return token
}

// 返回token登录需要携带的请求头
export function getTokenHeader() {
  const token = getToken()
  if (!token || token === 'null') return {}

  return {
    'X-Tsign-token-way': 'header',
    'X-Tsign-token': token,
  }
}
